module.exports = __webpack_public_path__ + "static/media/09.4d0af6ef.mp3";